import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  menuItem: {
    width: 76,
    height: 70,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 5,
    borderRadius: 8,
    paddingBottom: 7
  },
  icon: {
    borderRadius: '5px',
    height: 44,
    width: 44,
    display: 'flex',
    color: '#24378F',
    fontSize: 30,
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all .2s ease-in',
    '&:hover': {
      backgroundColor: '#00A88F',
      transform: 'translateY(-2px)'
    }
  },
  link: {
    color: 'black',
    textDecoration: 'none'
  },
  linkActive: {
    color: '#00A88F',
    '& #panelIcon': {
      backgroundColor: '#00A88F',
      borderRadius: '8px',
      color: '#f5f5f5'
    },
    '& #bold': {
      fontWeight: 'bold',
      textDecoration: 'none',
      textTransform: 'none'
    }
  },
  linkText: {
    color: '#24378F',
    fontSize: '14px',
    textDecoration: 'none'
  },
  size: {
    fontSize: 23
  },
  task: {
    display: 'flex',
    '@media all and (max-width: 1340px)': {
      display: 'none'
    }
  },
  clients: {
    display: 'flex',
    '@media all and (max-width: 1232px)': {
      display: 'none'
    }
  },
  expiry: {
    display: 'flex',
    '@media all and (max-width: 1300px)': {
      display: 'none'
    }
  },
  documents: {
    display: 'flex',
    '@media all and (max-width: 936px)': {
      display: 'none'
    }
  }
}))

export default useStyles
